import React, { useEffect } from "react";
import { SignUp } from "../../utils/api.constant";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Typography,
  Form,
  DatePicker,
  Row,
  Col,
  Table,
  Input,
} from "antd";
import styles from "./timeline-form.module.css";
import Text from "../../context/language-context";
import useDrawer from "../../hooks/useDrawer";
import { eResultCode, eTimeline, eUserType } from "../../utils/enum";
import {
  addEditTimeline,
  getTimeline,
  updateFormStatus,
} from "../../utils/api.constant";
import useFetch from "../../hooks/useFetch";
import { useForm } from "antd/es/form/Form";
import EncryptUtils from "../../utils/encrypt";
import { allowOnlyNumericInput_onKeyDown } from "../../utils/input.validator";
import { Regex } from "../../utils/validation";

const AddAdminDrawer = () => {
  const { onCloseDrawer } = useDrawer();
  const [form] = Form.useForm();
  const { post } = useFetch();

  const handleSubmit = async (values: {
    fullName: string;
    emailId: string;
    mobileNumber: number;
    password: string;
  }) => {
    try {
      const requestPayload = {
        data: {
          fullName: values.fullName,
          emailId: values.emailId.toLowerCase(),
          mobileNumber: values.mobileNumber,
          password: EncryptUtils.encrypt(values.password),
          userType: eUserType.ADMIN,
        },
      };
      const response = await post(SignUp, requestPayload);
      const { dataResponse } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
      }
    } catch (error) {
      console.error("Add Admin Error:", error);
    } finally {
    }
  };

  const PASSWORDS_DO_NOT_MATCH = Text({
    tid: "PASSWORDS_DO_NOT_MATCH",
    def: "The two passwords that you entered do not match!",
  });

  return (
    <div>
      <section className={styles.formHeader}>
        <Typography.Title
          level={3}
          style={{ marginBottom: "0px !important", color: "var(--bs-primary)" }}
        >
          {Text({ tid: "ADD_ADMIN", def: "Edit Timeline" })}
        </Typography.Title>

        <Button key="reject" variant="outlined" onClick={() => onCloseDrawer()}>
          {Text({ tid: "CLOSE", def: "Close" })}
        </Button>
      </section>
      <div className={styles.formWrapper}>
        <Form layout="vertical" onFinish={handleSubmit} form={form}>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item
                name="fullName"
                label={Text({
                  tid: "full_name",
                  def: "Full Name",
                })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item
                name="mobileNumber"
                label={Text({
                  tid: "mobile_number",
                  def: "Mobile Number",
                })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                  {
                    pattern: Regex.MOBILENO, // Updated pattern
                    message: Text({
                      tid: "mobile_number_validation",
                      def: "Enter a valid 10-digit mobile number",
                    }),
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  onKeyDown={allowOnlyNumericInput_onKeyDown}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item
                name="emailId"
                label={Text({
                  tid: "email_address",
                  def: "Email Address",
                })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item
                name="password"
                label={Text({ tid: "password", def: "Password" })}
                rules={[
                  {
                    required: true,
                    message: Text({
                      tid: "please_input_password",
                      def: "Please input your password!",
                    }),
                  },
                  {
                    pattern:
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    message: Text({
                      tid: "PASSWORD_REQUIREMENTS",
                      def: "Password must be at least 8 characters long, include uppercase, lowercase, number, and special character!",
                    }),
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item
                name="confirmPassword"
                label={Text({
                  tid: "confirm_password",
                  def: "Confirm Password",
                })}
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: Text({
                      tid: "PLEASE_INPUT_PASSWORD",
                      def: "Please confirm your password!",
                    }),
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(PASSWORDS_DO_NOT_MATCH));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={24}>
              <Form.Item className={styles.formFooter}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ float: "right" }}
                >
                  {Text({ tid: "SUBMIT", def: "Submit" })}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default AddAdminDrawer;
